export default __webpack_public_path__ + "static/media/pp-icon-active.3b6bbbde.svg";